<template>
  <div class="flex c-items-center c-justify-center c-flex-col">
    <svg
      class="icon loading c-p-1 text-dark opacity-50"
      width="100"
      height="100"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 36 36"
    >
      <path
        d="M35 19.27c-.43 0-.65-.23-1.19-.92-.73-.94-1.83-2.35-4.48-2.35-2.65 0-3.76 1.42-4.49 2.35-.54.7-.76.92-1.18.92-.43 0-.64-.22-1.18-.92C21.75 17.42 20.65 16 18 16c-2.65 0-3.75 1.41-4.48 2.35l-.12.15c-.46.58-.67.77-1.07.77-.43 0-.64-.22-1.18-.92-.72-.93-1.82-2.35-4.48-2.35s-3.76 1.42-4.49 2.35c-.54.7-.75.92-1.18.92-.55 0-1 .45-1 1 0 .09.01.19.04.27C.65 29.23 8.5 36 18 36s17.35-6.77 17.96-15.45c.02-.09.04-.18.04-.27 0-.56-.45-1.01-1-1.01zM18 34C9.79 34 2.98 28.38 2.1 21.06c.76-.32 1.25-.95 1.67-1.48.65-.85 1.22-1.58 2.9-1.58s2.24.73 2.9 1.58c.58.76 1.31 1.69 2.76 1.69 1.45 0 2.18-.94 2.77-1.69l.09-.12c.62-.8 1.22-1.46 2.81-1.46 1.67 0 2.24.73 2.9 1.58.59.75 1.31 1.69 2.76 1.69 1.44 0 2.17-.94 2.76-1.69.66-.85 1.24-1.58 2.91-1.58 1.67 0 2.24.73 2.9 1.58.42.53.91 1.16 1.67 1.48C33.02 28.38 26.21 34 18 34z"
      />
      <circle
        cx="10"
        cy="8"
        r="2"
      />
      <circle
        cx="18"
        cy="2"
        r="2"
      />
      <circle
        cx="25"
        cy="9"
        r="3"
      />
    </svg>
    <p
      v-if="message"
      class="flex c-items-center c-justify-center c-py-2"
    >
      {{ message }}
    </p>
  </div>
</template>

<script setup>
defineProps({
  message: {
    type: String,
    default: undefined,
  },
})
</script>
